export class PaycodeActions {
  static readonly LOAD_REQUEST = 'support/paycode/LOAD_REQUEST';
  static readonly LOAD_SUCCESS = 'support/paycode/LOAD_SUCCESS';
  static readonly LOAD_ERROR = 'support/paycode/LOAD_ERROR';

  static readonly LOAD_LIST_SUCCESS = 'support/paycode/LOAD_LIST_SUCCESS';

  static readonly SET_CURRENT_PAGE = 'support/paycode/SET_CURRENT_PAGE';
}
